import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import LoadingPage from '../../components/LoadingPage';
import { db } from '../../../config/Fire';
import * as Constants from '../../../constants';
import { getUser } from '../../../reducers';
import Chats from '../../components/Chats';
import './styles.css';

const ChatHistoricalEmployee = props => {
    const[historicalProcedures, setHistoricalProcedures] = useState(null)

    const getHistoricalProcedures = user => {
        console.log("getHistoricalProcedures employee")
        if(user.employeeCategories) {
            const employeeCategories = Object.keys(user.employeeCategories);
            const proceduresMap = {}
            const getHistoricalProceduresPromises = []
            employeeCategories.forEach(employeeCategory => {
                const getHistoricalProceduresByCategoryRef = db.ref(`${Constants.MAIN_NODES.HISTORICAL_PROCEDURES}`).orderByChild("employeeCategory").equalTo(employeeCategory).once("value")
                .then(proceduresSnap => {
                    if(proceduresSnap.exists()) {
                        proceduresSnap.forEach(procedureSnap => {
                            const procedure = procedureSnap.val();
                            proceduresMap[procedure.id] = procedure;
                        });
                    }
                })
                .catch(err => {
                    console.log("Error getting procedures: " + JSON.stringify(err))
                })
                getHistoricalProceduresPromises.push(getHistoricalProceduresByCategoryRef)
            });
            Promise.all(getHistoricalProceduresPromises)
            .then(() => {
                setHistoricalProcedures(proceduresMap)
            })
            .catch(() => {
                setHistoricalProcedures({})
            })
        } else {
            setHistoricalProcedures({})
        }
        return <LoadingPage />
    }

    return (
        <div className="chatHistoricalEmployeeCont">
            {
                props.user ?
                    historicalProcedures !== null ?
                        <Chats procedures={historicalProcedures} enableChat={false} />
                        :
                        getHistoricalProcedures(props.user)
                    :
                    <LoadingPage />
            }
        </div>
    );
};

ChatHistoricalEmployee.propTypes = {
    
};

const mapDispatchToPropsActions = dispatch => ({
    
});

const mapStateToProps = state => ({ 
    user:  getUser(state),
});

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(ChatHistoricalEmployee));